import { type AD_NETWORK, type UserProfile } from '@/shared/api/user/types';
import { type PlatformEvent } from '@/shared/service/analytics/types';

export const makeAdvertisementEvent = (
  value: any,
  {
    sessionId,
    gameKey,
    profile,
    adNetwork,
    source,
    eventName,
    eventProps,
  }: {
    sessionId: string;
    gameKey: string | undefined;
    profile: UserProfile | undefined;
    adNetwork: AD_NETWORK | null | undefined;
    source: string;
    eventName: string;
    eventProps?: Record<string, any>;
  }
): PlatformEvent => {
  return {
    type: 'ad',
    user_properties: {
      ...value?.user_properties,
      session_id: sessionId,
      telegramId: profile?.telegramId,
    },
    event_properties: {
      ...eventProps,
      ...value?.event_properties,
      name: eventName,
      view_source: source,
      avd_network: adNetwork,
      game_key: gameKey,
    },
  };
};
